import React, { useState, useEffect } from "react";

const MiniCountdown = () => {
    const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

    useEffect(() => {
        // Target date: Today + 2 days (dynamic check for demo purposes)
        const target = new Date();
        target.setDate(target.getDate() + 2);

        const interval = setInterval(() => {
            const now = new Date();
            const diff = target - now;

            if (diff <= 0) {
                clearInterval(interval);
                setTime({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                return;
            }

            setTime({
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((diff / (1000 * 60)) % 60),
                seconds: Math.floor((diff / 1000) % 60),
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex gap-3 justify-center items-center py-2 backdrop-blur-sm bg-black/20 rounded-xl px-4 border border-white/10 scale-90 origin-center">
            {/* Days */}
            <div className="flex flex-col items-center">
                <span className="text-xl md:text-2xl font-serif text-white drop-shadow-md">
                    {String(time.days).padStart(2, '0')}
                </span>
                <span className="text-[8px] uppercase tracking-widest text-white/60">GG</span>
            </div>

            <div className="h-6 w-[1px] bg-white/20" />

            {/* Hours */}
            <div className="flex flex-col items-center">
                <span className="text-xl md:text-2xl font-serif text-white drop-shadow-md">
                    {String(time.hours).padStart(2, '0')}
                </span>
                <span className="text-[8px] uppercase tracking-widest text-white/60">ORE</span>
            </div>

            <div className="h-6 w-[1px] bg-white/20" />

            {/* Minutes */}
            <div className="flex flex-col items-center">
                <span className="text-xl md:text-2xl font-serif text-white drop-shadow-md">
                    {String(time.minutes).padStart(2, '0')}
                </span>
                <span className="text-[8px] uppercase tracking-widest text-white/60">MIN</span>
            </div>

            <div className="h-6 w-[1px] bg-white/20" />

            {/* Seconds */}
            <div className="flex flex-col items-center">
                <span className="text-xl md:text-2xl font-serif text-white drop-shadow-md w-8 text-center">
                    {String(time.seconds).padStart(2, '0')}
                </span>
                <span className="text-[8px] uppercase tracking-widest text-white/60">SEC</span>
            </div>
        </div>
    );
};

export default MiniCountdown;
